import React from 'react';
import img from '../../../../Images/seminar.png'

const Seminar = () => {
    return (
        <section className='pb-5'>
            <div className="container">
                <h1 className='fw-bold fs-1 text-center  p-5' style={{ color: 'rgb(26, 62, 52, 77)' }}>SEMINAR</h1>
                <div className="row align-items-center">
                    <div className="col-md-5">
                        <img className='img-fluid rounded' src={img} alt="" />
                    </div>
                    <div className="col-md-7">
                        <div>
                            <h2 className='fw-bolder fs-1 text-center' style={{ color: 'rgb(35, 35, 35)' }} >JOIN MY SEMINAR</h2>
                            <div>
                                <p className='fs-5 fw-bold' style={{ color: 'rgb(61, 61, 61)' }}>Join my free Seminar to make your dream bigger. If you want to see yourself in the best position that you desire. You must come to my seminar. Remember One decision that will change your life. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Seminar;